import { render, staticRenderFns } from "./LeaveWallchart.vue?vue&type=template&id=9cf59a24&scoped=true"
import script from "./LeaveWallchart.vue?vue&type=script&lang=js"
export * from "./LeaveWallchart.vue?vue&type=script&lang=js"
import style0 from "./LeaveWallchart.vue?vue&type=style&index=0&id=9cf59a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf59a24",
  null
  
)

export default component.exports